export class BookFlightFormSearchFlight {
  term: string;
  airport: string;
}
